import {IdNameString} from '@core/src/public-api';

const localeKeyLong = {
  ES: 'es-Es',
  ESLT: 'es-Lt',
  FR: 'fr-Fr',
  AR: 'ar-Ar',
  OP: 'op-Op',
  ENGB: 'en-Gb',
  ENUS: 'en-Us',
  CA: 'ca-Es',
  DEFAULT: 'es-Es'
};

const localeKeyShort = {
  ES: 'es',
  ESLT: 'lt',
  FR: 'fr',
  AR: 'ar',
  OP: 'op',
  ENGB: 'en',
  ENUS: 'enus',
  CA: 'ca',
  DEFAULT: 'es'
};

const localeKeyLongToShort = {
  [localeKeyLong.ES]: localeKeyShort.ES,
  [localeKeyLong.ESLT]: localeKeyShort.ESLT,
  [localeKeyLong.FR]: localeKeyShort.FR,
  [localeKeyLong.AR]: localeKeyShort.AR,
  [localeKeyLong.OP]: localeKeyShort.OP,
  [localeKeyLong.ENGB]: localeKeyShort.ENGB,
  [localeKeyLong.ENUS]: localeKeyShort.ENUS,
  [localeKeyLong.CA]: localeKeyShort.CA
};

const localeKeyShortToLong = {
  [localeKeyShort.ES]: localeKeyLong.ES,
  [localeKeyShort.ESLT]: localeKeyLong.ESLT,
  [localeKeyShort.FR]: localeKeyLong.FR,
  [localeKeyShort.AR]: localeKeyLong.AR,
  [localeKeyShort.OP]: localeKeyLong.OP,
  [localeKeyShort.ENGB]: localeKeyLong.ENGB,
  [localeKeyShort.ENUS]: localeKeyLong.ENUS,
  [localeKeyShort.CA]: localeKeyLong.CA
};

const languageValues: IdNameString[] = [
  {id: localeKeyLong.ES, name: 'SI_SPANISH'},
  {id: localeKeyLong.CA, name: 'SI_VALENCIAN'},
  {id: localeKeyLong.ENUS, name: 'SI_ENGLISH'}
];

export {
  localeKeyLong,
  localeKeyShort,
  localeKeyLongToShort,
  localeKeyShortToLong,
  languageValues
};
